<template>
  <v-card width="100%" class="rounded-xl" id="approval">
    <v-toolbar color="warning">
      <v-toolbar-title>
        <v-icon class="mr-2">mdi-account-check</v-icon>
        Cases Requiring Approval
      </v-toolbar-title>
      <v-spacer />
      <v-btn icon @click="extended = !extended">
        <v-icon>mdi-magnify</v-icon>
      </v-btn>
    </v-toolbar>
    <CaseSearch v-model="caseFilter" :extended="extended" color="warning" />
    <v-card-text>
      <v-card class="overflow-y-auto" flat max-height="600">
        <div
          class="ma-0 py-1"
          v-for="(kase, index) in filteredApprovalCases"
          :key="index"
        >
          <v-lazy>
            <CaseCard :kase="kase" />
          </v-lazy>
        </div>
      </v-card>
      <div v-if="filteredApprovalCases.length === 0" class="text-center my-5">
        <v-icon>mdi-sleep</v-icon>
        <br />
        No cases found...
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import CaseCard from "@/components/shared/CaseCard";
import CaseSearch from "@/components/shared/CaseSearch";

export default {
  name: "ApprovalRequiredCases",
  components: {
    CaseCard,
    CaseSearch,
  },
  data() {
    return {
      caseFilter: "",
      extended: false,
    };
  },
  computed: {
    ...mapGetters(["approvalRequiredCases"]),
    filteredApprovalCases() {
      if (!this.caseFilter) {
        return this.approvalRequiredCases;
      }
      return this.approvalRequiredCases.filter((approvalRequiredCase) => {
        return (
          `${approvalRequiredCase.collection_id}`.includes(this.caseFilter) ||
          approvalRequiredCase.patient_reference
            .toLowerCase()
            .includes(this.caseFilter.toLowerCase())
        );
      });
    },
  },
};
</script>
